import angular from 'angular'

import './element/element'
import './modal/modal'
import './vd-currency-settings/vd-currency-settings'
import './vd-modals-container/vd-modals-container'
import './vd-overlay/vd-overlay'
import './vd-splash/vd-splash'
import './vd-toast-notification/vd-toast-notification'
import './vd-window-delegate/vd-window-delegate'

import EscapeStackService from './vd-escape-stack/vd-escape-stack'

angular.module('vend.ui').service('vdEscapeStack', EscapeStackService)
